export default __webpack_public_path__ + "static/media/4547af1ea19651924231f9e1f8e93c27.png";